// Mirrors backend RBAC (server.py PERMISSIONS). UI gating only; backend enforces authoritatively.
const PARTNER_RELATIONS = ["view_crm", "change_status", "add_notes", "upload_attachments", "view_attachments", "manage_followups", "manage_partners", "duplicate_itinerary", "view_dashboard"];

export const PERMISSIONS = {
  super_admin: ["manage_users", "manage_settings", "manage_content", "publish_content", "duplicate_itinerary", "view_crm", "view_all_leads", "assign_leads", "change_status", "add_notes", "export_data", "delete_records", "archive_records", "restore_records", "view_activity_logs", "upload_attachments", "view_attachments", "manage_followups", "manage_partners", "view_dashboard"],
  admin: ["manage_users", "manage_settings", "manage_content", "publish_content", "duplicate_itinerary", "view_crm", "view_all_leads", "assign_leads", "change_status", "add_notes", "export_data", "archive_records", "restore_records", "view_activity_logs", "upload_attachments", "view_attachments", "manage_followups", "manage_partners", "view_dashboard"],
  manager: ["manage_settings", "manage_content", "publish_content", "duplicate_itinerary", "view_crm", "view_all_leads", "assign_leads", "change_status", "add_notes", "export_data", "view_activity_logs", "upload_attachments", "view_attachments", "manage_followups", "manage_partners", "view_dashboard"],
  partner_relations: PARTNER_RELATIONS,
  sales: PARTNER_RELATIONS,
  operations: ["view_crm", "change_status", "add_notes", "upload_attachments", "view_attachments", "view_dashboard"],
  accounts: ["view_dashboard", "export_data"],
  content_manager: ["manage_content", "publish_content", "duplicate_itinerary", "view_dashboard"],
};

export const ROLE_LEVEL = { super_admin: 100, admin: 90, manager: 70, accounts: 50, content_manager: 50, partner_relations: 40, sales: 40, operations: 30 };

export function can(user, perm) {
  if (!user) return false;
  const role = PERMISSIONS[user.role] ? user.role : "super_admin";
  return PERMISSIONS[role].includes(perm);
}

// Only roles at or below the actor's own level may be assigned.
export function canGrant(actorRole, targetRole) {
  return (ROLE_LEVEL[targetRole] ?? 999) <= (ROLE_LEVEL[actorRole] ?? 0);
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  manager: "Manager",
  accounts: "Accounts",
  content_manager: "Content Manager",
  partner_relations: "Partner Relations / Sales",
  sales: "Sales (legacy)",
  operations: "Operations",
};

// Roles offered in the create/edit user dropdowns (legacy 'sales' excluded).
export const ASSIGNABLE_ROLES = ["super_admin", "admin", "manager", "accounts", "content_manager", "partner_relations", "operations"];

export const PERM_LABELS = {
  manage_users: "Manage users & roles", manage_settings: "Manage settings", manage_content: "Manage content (CMS)",
  publish_content: "Publish content", duplicate_itinerary: "Duplicate itineraries", view_crm: "Access CRM",
  view_all_leads: "View all leads", assign_leads: "Assign leads", change_status: "Change status", add_notes: "Add notes",
  export_data: "Export data", delete_records: "Permanently delete", archive_records: "Archive records", restore_records: "Restore records", view_activity_logs: "View activity logs",
  upload_attachments: "Upload attachments", view_attachments: "View attachments", manage_followups: "Manage follow-ups",
  manage_partners: "Manage partners", view_dashboard: "View dashboard",
};
